const commonUtil = {};
const mobileReg = /^([0-9])*$/;
const emailReg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

commonUtil.isEmail = function (val) {
   return emailReg.test(val);
}

commonUtil.isMobile = function (val) {
    return mobileReg.test(val) && val.length >=8;
}

commonUtil.isValidMobile = function (val) {
    return val.length === 10;
}


commonUtil.isValidMobile = function (val) {
    return val.length === 10;
}

commonUtil.isJSON = function (str) {

    if (typeof str == 'string') {
        try {
            var obj=JSON.parse(str);
            if(typeof obj == 'object' && obj ){
                return true;
            }else{
                return false;
            }
        } catch(e) {
            console.log('error：'+str+'!!!'+e);
            return false;
        }
    }
    console.log('It is not a string!');
    return false;
}

export { commonUtil };
